
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('contacto', require('./components/Contacto.vue').default);
Vue.component('registrousuario', require('./components/RegistroUsuarios.vue').default);
Vue.component('resetpassword', require('./components/ResetPassword.vue').default);
Vue.component('changepassword', require('./components/ChangePassword.vue').default);
Vue.component('listacomposiciones', require('./components/ListaComposiciones.vue').default);
Vue.component('obtenerplantillas', require('./components/ObtenerPlantillas.vue').default);
//console.log(process.env.MIX_API_URL);
//console.log("APIURL : "+$("#api_url").val());
//axios.defaults.baseURL = process.env.MIX_API_URL;
axios.defaults.baseURL = $("#api_url").val();

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
